module.exports = __webpack_public_path__ + "img/d-step4.140fed5f.png";